import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledBreadcrumbsContainer = styled(Box)(() => ({
  '@media (max-width: 575px)': {
    marginLeft: '15px',
    marginTop: '18px',
    marginBottom: '6px',
  },
}));
